import { z } from "zod";

export const DocumentKindEnum = z.enum([
  "agenda",
  "minutes",
  "packet",
  "resolution",
  "exhibit",
  "audio",
  "video",
  "other",
]);

export const DocumentSchema = z.object({
  id: z.string().uuid(),
  meetingId: z.string().uuid().optional().nullable(),
  jurisdictionId: z.string().uuid(),
  kind: DocumentKindEnum,
  title: z.string().min(1),
  gcsUri: z.string().min(1).optional().nullable(),
  sha256: z.string().length(64).optional().nullable(),
  mimeType: z.string().optional().nullable(),
  pageCount: z.number().int().nonnegative().optional().nullable(),
  fetchedAt: z.string().datetime().optional().nullable(),
  textHash: z.string().optional().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Document = z.infer<typeof DocumentSchema>;

export const DocumentChunkSchema = z.object({
  id: z.string().uuid(),
  documentId: z.string().uuid(),
  ordinal: z.number().int().nonnegative(),
  text: z.string(),
  pageRange: z.tuple([z.number().int(), z.number().int()]).optional().nullable(),
  embedding: z.array(z.number()).length(768).nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type DocumentChunk = z.infer<typeof DocumentChunkSchema>;
